/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconChartPie4 = createReactComponent("outline", "chart-pie-4", "IconChartPie4", [["path", { "d": "M12 12l-6.5 5.5", "key": "svg-0" }], ["path", { "d": "M12 3v9h9", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }], ["path", { "d": "M12 12l5 7.5", "key": "svg-3" }]]);

export { IconChartPie4 as default };
//# sourceMappingURL=IconChartPie4.mjs.map
